import { NavLink, Outlet } from 'react-router';
import { useState } from 'react';
import { Boxes, CalendarCheck, CalendarDays, ClipboardList, FileText, Home, KeyRound, ListChecks, LogOut, MapPinned, MessageSquare, Plug, Users, Building2, Calculator, Wallet } from 'lucide-react';
import { NOME_PAPEL, pode, useSessao } from '../sessao';
import { Modal } from './Modal';
import { FormTrocarSenha } from './TrocarSenha';
import logo from '../assets/logo-ondark.png';

const MENU: { para: string; rotulo: string; icone: typeof Home; fim?: boolean; permissoes?: string[] }[] = [
  { para: '/', rotulo: 'Início', icone: Home, fim: true },
  { para: '/agenda', rotulo: 'Agenda', icone: CalendarDays },
  { para: '/mapa', rotulo: 'Mapa da equipe', icone: MapPinned, permissoes: ['equipe.localizacao'] },
  { para: '/os', rotulo: 'Ordens de serviço', icone: ClipboardList },
  { para: '/chamados', rotulo: 'Chamados', icone: MessageSquare },
  { para: '/orcamentos', rotulo: 'Orçamentos', icone: Calculator, permissoes: ['orcamentos.ver'] },
  { para: '/despesas', rotulo: 'Despesas', icone: Wallet, permissoes: ['despesas.ver'] },
  { para: '/clientes', rotulo: 'Clientes', icone: Building2 },
  { para: '/ativos', rotulo: 'Parque instalado', icone: Boxes },
  { para: '/contratos', rotulo: 'Contratos', icone: FileText, permissoes: ['contratos.ver'] },
  { para: '/preventivas', rotulo: 'Preventivas', icone: CalendarCheck, permissoes: ['contratos.ver', 'os.agendar'] },
  { para: '/checklists', rotulo: 'Checklists', icone: ListChecks, permissoes: ['checklist.ver'] },
  { para: '/equipe', rotulo: 'Equipe', icone: Users, permissoes: ['usuarios.ver', 'usuarios.gerir', 'veiculos.gerir'] },
  { para: '/integracoes', rotulo: 'Integrações', icone: Plug, permissoes: ['integracoes.ver'] },
];

export function Moldura() {
  const { usuario, sair } = useSessao();
  const [senha, setSenha] = useState(false);
  return (
    <div className="moldura">
      <aside className="lateral">
        <div className="lateral-marca">
          <img src={logo} alt="Vivium" />
          <span className="produto">Ops</span>
        </div>
        <nav aria-label="Principal">
          {MENU.filter((m) => !m.permissoes || pode(usuario, ...m.permissoes)).map(({ para, rotulo, icone: Icone, fim }) => (
            <NavLink key={para} to={para} end={fim} className={({ isActive }) => `item-menu${isActive ? ' ativo' : ''}`}>
              <Icone size={19} strokeWidth={1.7} aria-hidden />
              <span>{rotulo}</span>
            </NavLink>
          ))}
        </nav>
        <div className="lateral-rodape">Uma marca Maza Automação.</div>
      </aside>
      <div className="principal">
        <header className="topo">
          <div className="usuario">
            <span className="avatar" aria-hidden>{usuario?.nome.slice(0, 1).toUpperCase()}</span>
            <div>
              <strong>{usuario?.nome}</strong>
              <small>{NOME_PAPEL[usuario?.papel ?? ''] ?? usuario?.papel}</small>
            </div>
          </div>
          <button className="btn-fantasma" onClick={() => setSenha(true)} aria-label="Trocar senha" title="Trocar senha">
            <KeyRound size={17} strokeWidth={1.7} aria-hidden /> <span className="so-desktop">Senha</span>
          </button>
          <button className="btn-fantasma" onClick={sair}>
            <LogOut size={17} strokeWidth={1.7} aria-hidden /> Sair
          </button>
        </header>
        <main className="conteudo">
          <Outlet />
        </main>
        <Modal titulo="Trocar senha" aberto={senha} aoFechar={() => setSenha(false)}>
          <FormTrocarSenha aoTerminar={() => setSenha(false)} />
        </Modal>
      </div>
    </div>
  );
}
